
































































































































































































import Vue from 'vue'
export default Vue.extend({
  props: ['cms'],
  data() {
    return {
      newCms: this.cms,
    }
  },
  methods: {
    setCms() {
      this.$root.$emit('set-cms', this.newCms)
    },
  },
  watch: {
    newCms: async function () {
      this.setCms()
    },
  },
})
